import { render, staticRenderFns } from "./HowToCreateStoriesModal.vue?vue&type=template&id=07c1183f&scoped=true&"
import script from "./HowToCreateStoriesModal.vue?vue&type=script&lang=js&"
export * from "./HowToCreateStoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./HowToCreateStoriesModal.vue?vue&type=style&index=0&id=07c1183f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1183f",
  null
  
)

export default component.exports